import React from "react";
import { Link } from 'react-router-dom'
import hero1 from '../../images/slider/1.png'

// TODO
/*

3. Replace logo with work four
4. Fix up 4 thingamabobs

*/

const Hero = ({data}) => {

    const ClickHandler = () => {
        window.scrollTo(10, 0);
    }

    return (
        <section 
        className="static-hero"
        style={{ backgroundImage: 'url("/images/DenverSkyline.png")' }}
        >
            <div className="hero-container">
                <div className="hero-inner">
                    <div className="container-fluid">
                        <div className="hero-content">
                            <div data-swiper-parallax="300" className="slide-title-sub">
                                <span
                                style={{  // color: "#3DA9FC;",
                                    textShadow: "0 2px 4px rgba(0, 0, 0, 0.4);"}}
                                >{data.heroSlideTitleSub}</span>
                            </div>
                            <div data-swiper-parallax="300" className="slide-title">
                                <h2>{data.heroTitle}</h2>
                            </div>
                            <div data-swiper-parallax="400" className="slide-text">
                                <p>{data.heroSlideText}</p>
                            </div>

                            <div className="clearfix"></div>
                            <div data-swiper-parallax="500" className="slide-btns">
                                <Link onClick={ClickHandler} to={data.heroBtnHref} className="theme-btn" id="mbl-thm-btn">{data.heroBtnText}</Link>
                            </div>
                            {/* <div className="politian-pic">
                                <img src={hero1} alt="" />
                                <div className="politian-shape">
                                    <div className="shape-1"></div>
                                    <div className="shape-2"></div>
                                    <div className="shape-3"></div>
                                    <div className="shape-4"></div>
                                </div>
                            </div> */}
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default Hero;